import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getZonesOptions } from "../../actions/actionZones";
import {Helmet} from "react-helmet";
import { store } from "../../store";

export const ping = (checkzone) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(checkzone.host + '/checkvalid')
      if (!response.ok) {
        reject(checkzone)
      }
      resolve(checkzone)
    } catch (e) {
      reject(checkzone)
    }
  })
}

export const findFastestZone = async () => {

  let { response: { zones } } = await store.dispatch(getZonesOptions())

  if (zones.length === 1) {
    let value = zones[0].host
    window.localStorage.setItem("best_zone", JSON.stringify(zones[0]))
    return value
  }

  const value = await Promise.any(zones.map(checkzone => ping(checkzone))).then((value) => {
    window.localStorage.setItem("best_zone", JSON.stringify(value))
    return value
  });
  return value
}


export default function ZoneSelection(props) {
  const dispatch = useDispatch()

  const [zone, setZone] = useState(window.localStorage.getItem("best_zone") || null);

  const setFastestZone = async () => {
    
    const value = await findFastestZone()
    setZone(value)
  }

  useEffect(() => {
    if (zone === null) {
      setFastestZone()
    }
  }, []);

  useEffect(() => {
    if (props.pathname === '/userdashboard') {
      setFastestZone()
    }
  }, [props.pathname]);


  return (
    <React.Fragment>
    </React.Fragment>
  )
}

export function ZonePreload(props) {
  const dispatch = useDispatch()
  const [zones, setZones] = useState([])
  const getZones = async () => {
    let { response: { zones } } = await dispatch(getZonesOptions())
    setZones(zones)
  }
  useEffect(() => {
    getZones()
  }, []);

  return (
    <Helmet>
      {zones && zones.length > 0 && zones.map(zone => <link rel="preconnect" href={zone.host}></link>)}
    </Helmet>
  )
}

/* Below is the React 19 version */
/*export function ZonePreload(props) {
  const dispatch = useDispatch()
  const getZones = async () => {
    let { response: { zones } } = await dispatch(getZonesOptions())
    if (zones && zones.length > 0) {
      zones.map(zone => preconnect(zone.host))
    }
  }
  useEffect(() => {
    getZones()
  }, []);

}*/

